"use strict";
var fieldEntryDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'documenteditor/templates/fieldEntry.ng.html',
    controller: require('../controllers/fieldEntryCtrl'),
    link: function($scope) {}
  };
};
fieldEntryDirective.$inject = [];
module.exports = fieldEntryDirective;
